import React, {FC, useState, useCallback} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {Icon, Call, LiveChat} from '@optimaxdev/icons';

import classNames from 'classnames';

import {CART_BUTTON} from 'constants/analytics/events/cart';
import {useGetActualPhone} from 'desktop/hooks/useGetActualPhone/useGetActualPhone';
import {useHostSelector} from 'hooks/hostHooks/hostHooks';

import {getWorkingHours} from 'selectors/storeInfo';

import {CartSavePopup} from '../cartSavePopup/cartSavePopup';

import s from './customerService.scss';

const sendAnalytic = (handleType: string) => {
    sendDesktopAnalyticsEvent(CART_BUTTON, {
        action: 'Right Section',
        label: `${handleType} - Clicked`,
    });
};

/**
 * Component for Customer Service block in bottom of cart
 * @returns {ReactElement} CustomerService component
 */
export const CustomerService: FC = () => {
    const phone = useGetActualPhone();
    const workingHours = useHostSelector(getWorkingHours);

    const [isPopupVisible, setPopupVisibility] = useState(false);
    const closePopup = useCallback(() => setPopupVisibility(false), [setPopupVisibility]);

    const openChat = () => {
        if (window.adaEmbed) window.adaEmbed.toggle();
    };

    return (
        <>
            <div className={s.container}>
                <div className={classNames(s.title, s.unClickableTitle)}>
                    Prefer to order by phone or live chat?
                </div>
                <div className={s.buttonRow}>
                    <div>
                        <button
                            onClick={() => {
                                openChat();
                                sendAnalytic('Chat');
                            }}
                            className={s.linkBlock}
                            type="button"
                        >
                            <Icon className={s.icon} icon={LiveChat} />
                            Start Live Chat
                        </button>
                        <p className={s.description}>We’re here for you 24/7</p>
                    </div>
                    <div className={s.divider} />
                    <div>
                        <a
                            className={s.linkBlock}
                            href={`tel:+${phone}`}
                            onClick={() => sendAnalytic('Call')}
                        >
                            <Icon className={s.icon} icon={Call} />
                            {phone}
                        </a>
                        <p className={s.description}>{workingHours}</p>
                    </div>
                </div>
            </div>
            <CartSavePopup closePopup={closePopup} isVisible={isPopupVisible} />
        </>
    );
};
